/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SundayInputs */

const en_sunday = /** @type {(inputs: SundayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunday`)
};

const de_sunday = /** @type {(inputs: SundayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonntag`)
};

/**
* | output |
* | --- |
* | "Sunday" |
*
* @param {SundayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sunday = /** @type {((inputs?: SundayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SundayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sunday(inputs)
	return de_sunday(inputs)
});